import React from 'react'
interface StatusProcessingIconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export function StatusProcessingIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}: StatusProcessingIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Outer circle */}
      <circle cx="12" cy="12" r="10" />
      {/* Gears for processing */}
      <circle cx="9" cy="12" r="2" fill={color} />
      <circle cx="15" cy="12" r="2" fill={color} />
      {/* Connecting line */}
      <line x1="11" y1="12" x2="13" y2="12" />
      {/* Arrow indicating movement */}
      <path d="M12 6v2" />
      <path d="M12 16v2" />
    </svg>
  )
}
